Drupal.behaviors.notification = {
  attach: function () {
    const notification = document.querySelector(".notification");

    if (notification) {
      const close = document.querySelector("#notification-close");
      const hasClosedNotification = sessionStorage.getItem(
        "hasClosedNotification"
      );

      if (!hasClosedNotification) {
        notification.style.display = "flex";

        close.addEventListener("click", function () {
          sessionStorage.setItem("hasClosedNotification", true);
          notification.style.display = "none";
        });
      }
    }
  },
};
